<template>
  <div class="app-container">
    <div id="header-wrapper">
      <LocaleSelector v-if="displayLocaleSelector" />
    </div>
    <div class="main-content pt-1 pt-lg-5">
      <router-view />
    </div>

    <!-- Sliding Panel -->
    <SlidingPanel :isPanelVisible="isPanelVisible" :onClose="onClose">
      <BookingPanel />
      <template #bottom> <StickyBar :booking="selectedBooking" /></template>
    </SlidingPanel>

    <div id="footer-wrapper"></div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ComputedRef, onMounted } from 'vue'
  import { useStore } from 'vuex'

  // Components
  import SlidingPanel from './components/UI/SlidingPanel.vue'
  import BookingPanel from '@/components/common/BookingPanel.vue'
  import LocaleSelector from '@/components/UI/LocaleSelector.vue'
  import StickyBar from '@/components/ConfirmedReservations/BookingPanel/StickyBar.vue'

  // Config
  import { ModalId } from '@/config/modalIds'
  import { CookieName } from '@/config/cookies'

  // Cookies
  import Cookies from 'js-cookie'

  // Types
  import { CompanyLang, Locale } from '@/types'

  // Router
  import { useRoute } from 'vue-router'
  import { RouteConfig } from './config'

  // Composables
  import useDocumentTitle from "@/composables/useDocumentTitle"
  const {setDocumentTitle} = useDocumentTitle()

  const store = useStore()
  const route = useRoute()

  // computed
  const selectedBooking = computed(
    () => store.getters['booking/selectedBooking']
  )

  // Methos
  const onClose = (): void => {
    store.dispatch('booking/unselectBooking')
    store.commit('modal/close', ModalId.BOOKING_PANEL)
  }

  // Get the panel visibility state from Vuex
  const isPanelVisible = computed(() => {
    const checkIsOpen = store.getters['modal/isOpen']

    return checkIsOpen(ModalId.BOOKING_PANEL)
  })

  const locale: ComputedRef<Locale> = computed(() => {
    return store.getters.getLocale
  })

  const displayLocaleSelector: ComputedRef<boolean> = computed(() => {
    const companyLang = Cookies.get(CookieName.COMPANY_LANG) as
      | CompanyLang
      | undefined
    const company = Cookies.get(CookieName.COMPANY) as string | undefined
    return (
      locale.value === 'fr-FR-CSE' &&
      !companyLang &&
      !company &&
      route.path === `/account/${RouteConfig.LOGIN}`
    )
  })


  onMounted(() => {
    setDocumentTitle()
  })
</script>

<style scoped>
  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .main-content {
    flex: 1;
    padding-bottom: 0; /* Default for desktop */
  }

  @media (max-width: 767px) {
    .main-content {
      padding-bottom: 86px; /* Height of the navbar on mobile */
    }
  }
</style>
